<template>
  <div class="off-ramp">
    <span @click="$emit('closeOffRamp')" class="close">X</span>
    <div class="grid-x grid-pading-x">
      <div class="cell small-12">
        <h1>You are now leaving this website</h1>
        <p>
          You have just clicked on a link that will take you to another website. This website is
          neither owned nor controlled by EQRx, Inc., which is not responsible for the content or
          services of that site or any further links from that site. EQRx, Inc. is providing these
          links to you only as a convenience, and the inclusion of any link does not imply the
          endorsement of the linked site or its content. Please be aware that the linked site may
          be governed by its own set of terms and conditions and privacy policy, for which EQRx,
          Inc. has no responsibility.
        </p>
        <h4>Do you wish to continue?</h4>
      </div>
    </div>
    <div class="grid-x grid-pading-x">
      <div class="cell small-5 medium-3">
        <a class="no-underline" :href="link">
          <button class="button rounded expanded">Yes</button>
        </a>
      </div>
      <div class="cell small-1">&nbsp;</div>
      <div class="cell small-5 medium-3">
        <button @click="$emit('closeOffRamp')" class="button expanded ghost">No</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OffRamp',
  props: [
    'link',
  ],
};
</script>

<style lang="scss">
  .off-ramp {
    position: fixed;
    top: 5%;
    right: 5%;
    bottom: 5%;
    left: 5%;
    background-color: #f4f4f4;
    z-index: 2;
    padding: 40px;
    border-radius: 20px;
    overflow: scroll;
  }

  .close {
    position: absolute;
    top: 3px;
    right: 3px;
    font-family: 'gorditaregular';
    font-size: 20px;
    color: #2e2e2e;
    text-align: center;
    width: 30px;
    height: 30px;
    display: inline-block;
    cursor: pointer;
    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  @media all and (max-width: 600px) {
    .off-ramp h1 {
      font-size: 30px;
    }
  }
</style>
